import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const API_URL = process.env.REACT_APP_API_URL || '';

function AccesoEncuesta() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, verify, error
  const [accessInfo, setAccessInfo] = useState(null);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/survey/access/${token}`)
      .then(res => {
        if (!res.ok) return res.json().then(d => { throw new Error(d.error); });
        return res.json();
      })
      .then(data => {
        setAccessInfo(data);
        setStatus('verify');
      })
      .catch(err => {
        setError(err.message || 'Enlace no válido');
        setStatus('error');
      });
  }, [token]);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setVerifying(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/api/survey/verify-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, email: email.trim() })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Error de verificación');
        setVerifying(false);
        return;
      }

      // Redirigir a la encuesta con el token de sesión
      navigate(`/encuesta/${data.surveyToken}`);
    } catch (err) {
      setError('Error de conexión. Inténtalo de nuevo.');
      setVerifying(false);
    }
  };

  if (status === 'loading') {
    return (
      <div className="public-container">
        <Header subtitle="Encuesta de Clima Laboral 2025" />
        <main className="public-main">
          <div className="public-card">
            <p className="public-loading">Verificando enlace...</p>
          </div>
        </main>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="public-container">
        <Header subtitle="Encuesta de Clima Laboral 2025" />
        <main className="public-main">
          <div className="public-card">
            <div className="public-icon" style={{ marginBottom: '20px' }}>&#128683;</div>
            <h1 className="public-title public-title--sm" style={{ color: '#c33' }}>Acceso no disponible</h1>
            <p className="public-subtitle public-subtitle--sm">{error}</p>
            <p style={{ fontSize: '14px', color: '#888' }}>
              Si crees que es un error, contacta con el departamento de RRHH.
            </p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="public-container">
      <Header subtitle="Encuesta de Clima Laboral 2025" />
      <main className="public-main">
        <div className="public-card">
          <div className="public-icon" style={{ marginBottom: '20px' }}>&#128274;</div>
          <h1 className="public-title public-title--sm">Verificación de acceso</h1>
          <p className="public-subtitle public-subtitle--sm">
            Para acceder a la encuesta, introduce tu correo electrónico corporativo para verificar tu identidad.
          </p>

          {error && <div className="public-error">{error}</div>}

          <form onSubmit={handleVerify}>
            <div>
              <label className="public-label">Correo electrónico</label>
              <input
                type="email"
                className="public-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu.nombre@emiliomoro.com"
                required
                autoFocus
              />
              {accessInfo?.emailHint && (
                <p className="public-hint">
                  Pista: {accessInfo.emailHint}
                </p>
              )}
            </div>

            <button
              type="submit"
              className="public-button"
              disabled={verifying || !email.trim()}
            >
              {verifying ? 'Verificando...' : 'Acceder a la encuesta'}
            </button>
          </form>

          <div className="public-info public-info--sm">
            <strong>Encuesta:</strong> {accessInfo?.campaignNombre}<br />
            <strong>Tipo:</strong> {accessInfo?.tipoEncuesta === 'directivo' ? 'Comité Directivo' : 'Colaborador'}
            {accessInfo?.departamento && (
              <><br /><strong>Departamento:</strong> {accessInfo.departamento}</>
            )}
            <br /><br />
            La encuesta es 100% anónima. La verificación solo sirve para controlar el acceso, tus respuestas no se vincularán a tu identidad.
          </div>
        </div>
      </main>
    </div>
  );
}

export default AccesoEncuesta;
